/* eslint-disable react/jsx-handler-names */
import React, { Component, PropTypes } from "react"
import { getUploads, initAdditionalUpload } from "state/actions"
import { sortBy } from "lodash/collection"
import Collapse from "react-collapse"
import RefreshBtn from "../refreshBtn"
import { dateFormatter } from "lib/helpers"
import { Table, Thead, Th, Tr, Td } from "components/reactable"
import { UploaderTableComment } from "components/uploader/UploaderTableComment"
import pdfIcon from "resources/images/pdf-icon_1x.png"
import closeIcon from "resources/images/p-close_1x.png"
import folderIcon from "resources/icn-folder.svg"
import uploadIcon from "resources/upload.svg"
import uploadLockIcon from "resources/icn-upload-lock.svg"
import plusIcon from "resources/icn-plus.svg"
import Measure from "react-measure"
import cn from "classnames"
import i18n from "lib/i18n"
import rt from "../reactable.scss"
import styles from "./uploader.scss"

const _ = i18n("uploader")

const CommentIcon = () => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        height="24"
        viewBox="0 -960 960 960"
        width="24"
        fill="#898E91"
    >
        <path
            d="M260-420h280v-40H260v40Zm0-120h440v-40H260v40Zm0-120h440v-40H260v40ZM120-156.923v-618.462Q120-803 138.5-821.5 157-840 184.615-840h590.77Q803-840 821.5-821.5 840-803 840-775.385v430.77Q840-317 821.5-298.5 803-280 775.385-280H243.077L120-156.923ZM226-320h549.385q9.23 0 16.923-7.692Q800-335.385 800-344.615v-430.77q0-9.23-7.692-16.923Q784.615-800 775.385-800h-590.77q-9.23 0-16.923 7.692Q160-784.615 160-775.385v521.154L226-320Zm-66 0v-480 480Z"
        />
    </svg>

)

export default class UploaderTable extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isClosed: {},
            selected: props.selected || [],
            documentMetaCol: 0, // width of the document meta cell
            documentCheckBox: 0, // width of the document checkbox cell
            documentTypeCol: 0, // width of the document type cell
            documentDateCol: 0, // width of the document date cell
            userComment: 0, // width of the user comment cell
        }
    }

    /**
     * This function is unused maybe should delete it.
     * @param {*} item 
     */
    addFilesToUpload(item) {
        const { type, id, dispatch } = this.props
        dispatch(initAdditionalUpload(type, id, item))
    }

    switch(id) {
        this.setState({
            isClosed: {
                ...this.state.isClosed,
                [id]: !this.state.isClosed[id],
            },
        })
    }

    displayDate(date) {
        const d = new Date(date)
        return (("0" + d.getDate()).slice(-2) + "-" + ("0" + (d.getMonth() + 1)).slice(-2) + "-" + d.getFullYear())
    }

    /**
     * Thanks to legacy code, we have to log the width of the cell to avoid the overflow of the text.
     * @param {object} dimensions { width: number, height: number}
     * @param {string} cellName  "documentMetaCol" | "documentCheckBox" | "documentTypeCol" | "documentDateCol" | "userComment"
     */
    logCellWidth({ width }, cellName) {
        const cellWidth = this.state[cellName]
        if (cellWidth !== width) {
            this.setState({ [cellName]: width })
        }
    }

    onSelectDoc(requiredValues) {
        const { selectedUpdaterCallback } = this.props
        const { selected } = this.state
        let index = -1
        const newSelectedList = []

        selected.forEach((val, i) => {
            newSelectedList.push(val)
            if (val.id === String(requiredValues.id)) {
                index = i
            }
        })

        if (index === -1) {
            newSelectedList.push(requiredValues)
        } else {
            newSelectedList.splice(index, 1)
        }

        this.setState({ selected: newSelectedList }, () => {
            if (selectedUpdaterCallback && typeof selectedUpdaterCallback === "function") {
                selectedUpdaterCallback(this.state.selected)
            }
        })
    }

    opendDocumentInNewWindow(item) {
        if (item.document) {
            window.open(`/data/document?id=${item.uploadId}&docType=${encodeURI(item.type)}&uploadDate=${encodeURI(item.uploadDate)}`, "_blank", 'noopener,noreferrer')
        } else if (item.amount >= 1) {
            this.switch(item.uploadId)
        }
    }

    /**
     * This function handle the refresh functionality, update the selection list also for the parent module.
     */
    handleRefreshTable() {
        const { selectedUpdaterCallback, type, id, dispatch } = this.props

        return dispatch(getUploads(type, id, true)).then(() => {
            // after refreshing attachments we must tell the changes again for parent module
            if (selectedUpdaterCallback && typeof selectedUpdaterCallback === "function") {
                selectedUpdaterCallback(this.state.selected)
            }
        })
    }

    /**
     * This function is used to prevent the navigation when the user is typing in the comment field.
     */
    isUserCommentCellClick = (event) => {
        let preventNavigation = false
        const {target} = event
        const textareaEl = target.querySelector("textarea") || target
        if ((textareaEl && textareaEl.name) === "user_comment_textarea") {
            preventNavigation = true
        }
        return preventNavigation
    }

    /**
     * This will return with the correct title for the table what describe the type of documents.
     */
    renderTitleForTable(type) {
        return (
            <div className={rt.tableTitle}>
                {(type === "client" && _("clientDocuments")) ||
                    (type === "claim" && _("claimDocuments")) ||
                    (type === "contract" && _("contractDocuments")) ||
                    (type === "tarification" && _("tarificationDocuments")) ||
                    _("documents")}
            </div>
        )
    }

    /**
     * Resolve the document comment field based on the document structurture.
     * @param {object} file claim | client | contract | tarification
     * @returns {object} { commentKey: string | null, commentValue: string}
     */
    resolveDocumentComment = (file) => {
        let commentValue = ''
        let commentKey = null
        const commentKeys = ['clientDocumentBemComment', 'contractDocumentBemComment', 'tarificationDocBemComment', 'documentBemComment']
        commentKeys.forEach((key) => {
            if (Object.prototype.hasOwnProperty.call(file, key)) {
                commentKey = key
                commentValue = file[key]
                return
            }
        })
        return { commentKey, commentValue }
    }

    render() {
        const { id, type, files, documents, dict, openModal, selectable, canUpload, onlyUploadButton, classNameExtra } = this.props
        const { selected } = this.state
        let actFiles = []
		const selectedCheckboxes = (selected && selected.map((val) => val.id)) || []
        let uploads = null
        const customTableHeads = []
        const serviceUploadComments = ["DS_ORIGIN_LOCAL_UPLOAD", "DS_ORIGIN_ORACLE", "", undefined] // These comments are not displayed in the table

        if (files && type && id) {
            uploads = files[type][id]
        }
        if (type && type === "tarification") {
            customTableHeads.push("insuranceCompany")
        }

        if (uploads) {
            for (const file of uploads.files) {
                const tmp = {
                    ...file,
                    document: false,
                    amount: file.documents ? file.documents.length : 0,
                }
                actFiles = [...actFiles, tmp]
            }
        }

        if (documents) {
            for (const file of documents) {
                const tmp = {}
                const { commentKey, commentValue} = this.resolveDocumentComment(file)
                tmp.amount = 1
                tmp.locked = true
                tmp.document = true
                tmp[commentKey] = commentValue
                tmp.uploadDate = file.contractDocumentDate || file.clientDocumentDate || file.documentDate || file.tarificationDocDate
                tmp.type = file.contractDocumentType || file.clientDocumentType || file.documentType || file.tarificationDocType
                tmp.uploadId = file.contractDocumentId || file.clientDocumentId || file.documentId || file.tarificationDocId
                tmp.insuranceCompany = file.insuranceCompany || null
                actFiles = [...actFiles, tmp]
            }
        }

        // (v8.0) EXIT POINT (avoid to show the uploader table, hut the upload button in special cases)
        if (onlyUploadButton) {
            return (
                <div className={cn(styles.uploadsContainer, classNameExtra)}>
                    {dict && canUpload && (
                        <div
                            onClick={openModal}
                            className={cn(styles.uploadButton, 'btn', 'green')}
                        >
                            <div className={styles.iconContainer}><img src={plusIcon}/></div>
                            {_("upload")}
                        </div>
                    )}
                </div>
            )
        }

        return (
            <div className={styles.uploadsContainer}>
                <div className={rt.tableContainer}>
                    {this.renderTitleForTable(type)}
                    <Table
                        filterPlaceholder={_("placeholder")}
                        topPaginationElemL={
                            <RefreshBtn onClick={() => {this.handleRefreshTable()}}/>
                        }
                        topPaginationElemR={
                            (dict && canUpload) && (
                                <div onClick={openModal} className={cn(styles.uploadButton, "btn green")}>
                                    <div className={styles.iconContainer}>
                                        <img src={require("resources/icn-plus.svg")}/>
                                    </div>
                                    {_("upload")}
                                </div>
                            )
                        }
                        className={styles.uploadTable}
                        itemsPerPage={40}
                        filterable={["documentHiddenCol", "documentTypeCol", "documentDateCol"]}
                        sortable={[
                            { column: "documentDateCol", sortFunction: "Date" },
                            "documentTypeCol",
                            "documentAmount",
                        ]}
                        defaultSort={{column: "documentDateCol", direction: "desc"}}
                    >
                        <Thead>
                            <Th column="documentMetaCol">
                                <Measure accurate onMeasure={(dim) => this.logCellWidth(dim, 'documentMetaCol')}>
                                    <div>{""}</div>
                                </Measure>
                            </Th>
                            <Th className={rt.documentHidden} column="documentHiddenCol"/>
                            <Th column="documentCheckBox">
                                <Measure accurate onMeasure={(dim) => this.logCellWidth(dim, 'documentCheckBox')}>
                                    <div>{""}</div>
                                </Measure>
                            </Th>
                            <Th column="documentTypeCol">
                                <Measure accurate onMeasure={(dim) => this.logCellWidth(dim, 'documentTypeCol')}>
                                    <div>
                                        <strong>{_("documentType")}</strong>
                                    </div>
                                </Measure>
                            </Th>
                            <Th column="documentDateCol">
                                <Measure accurate onMeasure={(dim) => this.logCellWidth(dim, 'documentDateCol')}>
                                    <div>
                                        <strong>{_("documentDate")}</strong>
                                    </div>
                                </Measure>
                            </Th>
                            <Th column="userComment">
                                <Measure accurate onMeasure={(dim) => this.logCellWidth(dim, 'userComment')}>
                                    <div>
                                        <strong>{_("userComment")}</strong>
                                    </div>
                                </Measure>
                            </Th>
                            {customTableHeads.map((header, index) => (
								<Th key={`${header}-${index}`} column={header}>
									<strong>{_(header)}</strong>
								</Th>
                            ))}
                            {/* <Th column="documentUpload"><strong>{_("upload")}</strong></Th> */}
                        </Thead>
                        {actFiles.map((item, index) => (
							<Tr
								key={`${item.uploadId}-${index}`}
								className={rt.docRow}
								onClick={(event) => {
									if (this.isUserCommentCellClick(event)) {
                                        return // Here we prevent the navigation
                                    }
									this.opendDocumentInNewWindow(item)
								}}
							>
                                {item.document || item.amount === 0 ? (
                                    <Td
										column="documentMetaCol"
                                        data={item.id}
                                        className={styles.rowIcon}
                                    >
                                        <div>
                                            <img src={item.amount === 1 ? pdfIcon : closeIcon}/>
                                        </div>
                                    </Td>
                                ) : (
                                    <Td
                                        column="documentMetaCol"
                                        data={item.id}
                                        className={styles.rowIcon}
                                    >
                                        <div style={{ width: 10 }}>
                                            <div><img src={folderIcon}/></div>
                                            <Collapse
                                                className={styles.collapseFiles}
                                                isOpened={Boolean(!this.state.isClosed[item.uploadId])}
                                                onClick={(ev) => ev.stopPropagation()}
                                                style={{paddingLeft: this.state.documentMetaCol + 10}}
                                            >
                                                <div className={styles.collapseContent}>
                                                    {!serviceUploadComments.includes(item.comment) && (
                                                        <div className={styles.uploadCommentContainer}>
                                                            <div
                                                                style={{width: this.state.documentCheckBox + 20, padding: '10px'}}
                                                                className={styles.icon}
                                                            >
                                                               <CommentIcon/>
                                                            </div>
                                                            <p style={{width: this.state.documentTypeCol}}>{item.comment}</p>
                                                        </div>
                                                    )}
                                                    <div className={styles.documents}>
                                                        {item.amount >= 1 && sortBy(item.documents, (sdoc) => sdoc.documentType).map((doc, j) => (
															<div key={j} className={styles.documentRowHolder}>
																{selectable && (
																	<input
																		type="checkbox"
																		checked={selectedCheckboxes.indexOf(String(doc.documentId)) !== -1}
																		onChange={() => {
																			this.onSelectDoc({
																				id: String(doc.documentId),
																				name: doc.documentType,
																				date: doc.documentDate,
																			})
																		}}
																		value={doc.documentId}
																	/>
																)}
																<a
																	key={"anchor" + j}
																	className={styles.file}
																	onClick={(event) => {
                                                                        if (this.isUserCommentCellClick(event)) {
                                                                            return // Here we prevent the navigation
                                                                        }
																		window.open(
																			`/data/document?id=${
																				doc.documentId
																			}&docType=${encodeURI(
																				doc.documentType
																			)}&uploadDate=${encodeURI(
																				doc.documentDate
																			)}`,
																			"_blank",
                                                                            'noopener,noreferrer'
																		)
                                                                    }}
																>
																	<div style={{width: this.state.documentCheckBox + 20, padding: '10px'}} className={styles.rowIcon}>
																		<img src={pdfIcon}/>
																	</div>
																	<div style={{width: this.state.documentTypeCol + 20, padding: '10px' }} className={styles.documentType}>
																		{doc.documentType}
																	</div>
																	<div style={{width: this.state.documentDateCol + 20, padding: "10px"}}>
																		{this.displayDate(doc.documentDate)}
																	</div>
                                                                    <div className={styles.userComment} style={{padding: '10px', width: '52em'}}>
                                                                        <UploaderTableComment
                                                                            document={doc}
                                                                            typeId={id}
                                                                            uploadId={item.uploadId}
                                                                            uploadType={type}
                                                                        />
                                                                    </div>
																</a>
															</div>
														))}
                                                    </div>
                                                </div>
                                            </Collapse>
                                        </div>
                                    </Td>
                                )}
                                <Td
                                    style={{ display: "none" }}
                                    column="documentHiddenCol"
                                    data={
                                        !item.document && item.amount >= 1
                                            ? item.documents
                                                  .map(
                                                      (doc) =>
                                                          `${doc.documentType} ${doc.documentDate} ${doc.documentId}`
                                                  )
                                                  .join(" ")
                                            : ""
                                    }
                                />
                                <Td column="documentCheckBox">
                                    <div onClick={(ev) => {ev.stopPropagation()}}>
                                        {(selectable &&
                                            !item.document &&
                                            item.amount === 0 &&
                                            item.documents.map((doc, index) => (
                                                <input
													key={`${doc.documentId}-${index}`}
                                                    type="checkbox"
                                                    checked={selectedCheckboxes.indexOf(String(doc.documentId)) !== -1}
                                                    onChange={() => {
                                                        this.onSelectDoc({
                                                            id: item.documentId,
                                                            name: item.documentType,
                                                            date: item.documentDate,
                                                        })
                                                    }}
                                                    value={doc.documentId}
                                                />
                                            ))) ||
                                            (selectable && item.document && (
                                                <input
                                                    type="checkbox"
                                                    checked={selectedCheckboxes.indexOf(String(item.uploadId)) !== -1}
                                                    onChange={() => {
                                                        this.onSelectDoc({
                                                            id: item.uploadId,
                                                            name: item.type,
                                                            date: item.uploadDate,
                                                        })
                                                    }}
                                                    value={item.uploadId}
                                                />
                                            )) ||
                                            item.document}
                                    </div>
                                </Td>
                                <Td className={styles.documentTypeCol} column="documentTypeCol" data={item.type}/>
                                <Td column="documentDateCol" data={dateFormatter(item.uploadDate)}/>
                                <Td column="userComment" className={styles.userComment} style={{padding: '10px', width: '52em'}}>
                                    <UploaderTableComment
                                        document={item}
                                        typeId={id}
                                        uploadId={item.uploadId}
                                        uploadType={type}
                                    />
                                </Td>
                                {type && type === "tarification" && (
                                    <Td column="insuranceCompany" data={item.insuranceCompany}/>
                                )}
                                {/* {item.document === false && (
                                    <Td
                                        className={rt.uploadCol}
                                        column="documentUpload"
                                        data={item.id}
                                    >
                                        {item.locked === "false" ? (
                                            <img
                                                className={styles.withPointer}
                                                onClick={(ev) => {
                                                    ev.stopPropagation()
                                                    return this.addFilesToUpload(item)
                                                }}
                                                src={uploadIcon}
                                            />
                                        ) : (
                                            <img onClick={(ev) => {ev.stopPropagation()}} src={uploadLockIcon}/>
                                        )}
                                    </Td>
                                )} */}
                            </Tr>
                        ))}
                    </Table>
                </div>
            </div>
        )
    }
}
UploaderTable.propTypes = {
	id: PropTypes.string.isRequired,
	type: PropTypes.string.isRequired,
	files: PropTypes.object,
	documents: PropTypes.array,
	dict: PropTypes.object,
	openModal: PropTypes.func.isRequired,
	dispatch: PropTypes.func.isRequired,
	selectable: PropTypes.bool,
	selected: PropTypes.array,
	selectedUpdaterCallback: PropTypes.func,
	onlyUploadButton: PropTypes.bool,
	classNameExtra: PropTypes.any,
	canUpload: PropTypes.bool,
}



// WEBPACK FOOTER //
// ./components/uploader/uploaderTable.jsx